const ApplicationTableHeader = ({ columns, renderer }) => <thead>
    <tr>
        {columns.map((col, key) => renderer({ ...col, key }))}
    </tr>
</thead>;

export default ApplicationTableHeader;